import React from 'react'
import { SurgicalScheduleModel } from 'domain/entities/surgical-schedule-model'
import Modal from 'presentation/shared/components/Modal'
import Divider from 'presentation/shared/components/DividerNew'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
import SurgeryDetailsInfo from 'presentation/hospital/components/SurgeryDetailsInfo'
import * as S from './styles'

type Props = {
  title: string
  showModalDetails: boolean
  setShowModalDetails: (condition: boolean) => void
  schedule: SurgicalScheduleModel
}

const ScheduleDetailsModal = ({
  title = '',
  showModalDetails,
  setShowModalDetails,
  schedule
}: Props) => {
  return (
    <>
      {schedule && (
        <Modal
          style={{
            display: 'block',
            width: 'auto',
            padding: 20
          }}
          show={showModalDetails}
          close={() => setShowModalDetails(false)}
          preventAutomateClose
        >
          <S.ModalInfo>
            <S.Title>{title}</S.Title>
            <CloseIcon
              style={{ cursor: 'pointer' }}
              onClick={() => setShowModalDetails(false)}
            />
          </S.ModalInfo>
          <Divider />

          <SurgeryDetailsInfo surgicalSchedule={schedule} />
        </Modal>
      )}
    </>
  )
}

export default ScheduleDetailsModal
